import React from "react"
import Card from "@material-ui/core/Card"
import Paper from "@material-ui/core/Paper"
import { makeStyles } from "@material-ui/core/styles"
import CardMedia from "@material-ui/core/CardMedia"
import { Link } from "gatsby"
import Img from "gatsby-image"
import CardActionArea from "@material-ui/core/CardActionArea"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import style from "../styles/post.module.css"
import { toKebabCase } from "../helpers"

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    textAlign: "center",
    // color: theme.palette.text.secondary,
    width: 650,
    height: 300,
    margin: "10px",
    display: "flex",
    // maxWidth: 500,
    // maxHeight: 600,
    // borderRadius: "20px",
    // boxShadow: "0 15px 30px rgba(0, 0, 0, 0.1)",
  },
  media: {
    // borderRadius: "20px",
    // marginBottom: "40px",
    width: 200,
  },
  coverImage: {
    // margin: "5px",
    // position: "relative",
    // borderRadius: "8px",
    // boxShadow: "0 15px 30px rgba(0, 0, 0, 0.1)",
    // width: 200,
    // height: 200,
  },
  title: {
    textDecoration: "none",
    fontSize: "1.8rem",
    fontStyle: "bold",
    // maxWidth: "70%",
    fontColor: "black",
    // fontStyle: "normal!important",
    // fontWeight: 10,
    color: "black",
    lienHeight: "24px",
    margin: "0px",
    display: "inline-block",
    transition: "all 0.3s ubic-bezier(0.33, 0, 0.2, 1)",

    // margin: "0 0 0vw",
    // color: "var(--color-base)",
    // textAlign: "center",
  },

  postContent: {
    position: "relative",
    width: 400,
  },
  postContentExcerpt: {
    margin: "-2vw 0 3vw",
    fontSize: "2.2rem",
    lineHeight: "1.6em",
    color: "var(--color-base)",
    textAlign: "center",
    opacity: 0.5,
  },
  post: {
    width: "100%",
  },
}))

const PostCard = ({
  key,
  title,
  date,
  path,
  coverImage,
  author,
  excerpt,
  tags,
  html,
  previousPost,
  nextPost,
}) => {
  const classes = useStyles()

  return (
    <Paper className={classes.root}>
      <Link to={path} style={{ textDecoration: "none" }}>
        <CardActions>
          <div className={classes.postContent}>
            <div className={classes.title}>{title}</div>
            <div classname={classes.postContentExcerpt}>{excerpt}</div>
            <div className={style.meta}>
              {date} {author && <>— Written by {author}</>}
              {tags ? (
                <div className={style.tags}>
                  {tags.map((tag) => (
                    <Link
                      to={`/tags/${toKebabCase(tag)}/`}
                      key={toKebabCase(tag)}
                    >
                      <span className={style.tag}>#{tag}</span>
                    </Link>
                  ))}
                </div>
              ) : null}
            </div>
            <Link to={path} className={style.readMore}>
              Read more
            </Link>
          </div>
        </CardActions>
      </Link>
      <Link to={path} style={{ textDecoration: "none" }}>
        <CardActionArea>
          <CardContent>
            <CardMedia className={classes.media}>
              {coverImage && (
                <Img
                  fluid={coverImage.childImageSharp.fluid}
                  className={classes.coverImage}
                />
              )}
            </CardMedia>
          </CardContent>
        </CardActionArea>
      </Link>
    </Paper>
  )
}

export default PostCard
